module.exports = __webpack_public_path__ + "resources/img/img_ngs_m.e3fdae2a6630dcc9a09efcba8c0ac384.png";